export default __webpack_public_path__ + "static/media/forgot.79b6ad34.gif";